import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  .header {
    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }

    & > p {
      font-family: Sora, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #101d40;

      span {
        font-weight: 600;
      }
    }
  }

  form {
    display: flex;
    gap: 16px;
    flex-direction: column;

    .information {
      display: flex;
      gap: 16px;
      flex-direction: column;

      & > div {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 16px;

        & > div {
          min-width: 280px;
        }
      }
    }

    .image {
      display: flex;
      margin: 0 auto;
      min-width: 200px;
      max-width: 200px;
      min-height: 200px;
      max-height: 200px;

      div:first-child {
        border-radius: 50% !important;
        min-width: 100%;

        button:last-child {
          display: none;
        }
      }
    }

    .limitacao {
      flex: 1;

      label {
        display: block;
        margin-bottom: 6px;
        font-weight: 500;
        font-size: 14px;
        font-family: 'Sora', sans-serif;
        color: #101d40;
      }
    }

    button[type='submit'] {
      max-width: 300px;
      margin: 0 auto;
    }
  }
`;
